import "./style.scss";

export default function CloseButton({ onClick }) {
  return <button type="button" onClick={onClick} className="close-btn" />;
}
